<script>
	import {range} from './lib'

	export let panes
	export let cols

	const maxPanes = 6
	const maxCols = 3
</script>

<header>
	<h1>REMI</h1>

	<nav>
		<svg viewBox="0 0 2 3" aria-hidden="true" class="svelte-t2wq17"><path d="M0,0 L1,2 C1.5,3 1.5,3 2,3 L2,0 Z" class="svelte-t2wq17"></path></svg>
		<ul>
			<li>
				<label>
					Panes:
					<select bind:value={panes}>
						{#each range(1, maxPanes) as i}
							<option>{i}</option>
						{/each}
					</select>
				</label>
			</li>
			<li>
				<label>
					Cols:
					<select bind:value={cols}>
						{#each range(1, maxCols) as i}
							<option>{i}</option>
						{/each}
					</select>
				</label>
			</li>
			<!--
			<li><a href=# on:click|preventDefault={() => panes = 6}>Seši</a></li>
			-->
		</ul>
		<svg viewBox="0 0 2 3" aria-hidden="true" class="svelte-t2wq17"><path d="M0,0 L0,3 C0.5,3 0.5,3 1,2 L2,0 Z" class="svelte-t2wq17"></path></svg>
	</nav>
</header>

<style>
	header {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
	}

	h1 {
		color: var(--orange);
		background: linear-gradient(90deg, var(--white), transparent, transparent);
		padding-left: var(--spacing-sm);
		text-transform: uppercase;
		font-size: var(--text-xl);
		font-weight: var(--text-light);
		letter-spacing: .07em;
	}


	nav {
		--background: var(--white);
		display: flex;
		justify-content: center;
		font-size: var(--text-sm);
	}

	svg {
		width: 1.6rem;
		height: 2.4rem;
		display: block;
	}

	path {
		fill: var(--background);
	}

	ul {
		background: var(--background);
		position: relative;
		padding: 0;
		margin: 0;
		height: 3em;
		display: flex;
		justify-content: center;
		align-items: center;
		list-style: none;
		background-size: contain;
	}

	li {
		position: relative;
		height: 100%;
	}

	/* FOR THE MENU
	a {
		display: flex;
		height: 100%;
		align-items: center;
		padding: 0 1em;
		color: var(--black);
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: .1em;
		text-decoration: none;
		transition: color .2s linear;
	}

	a:hover {
		color: var(--orange);
	}

	a.active::before {
		--size: 6px;
		content: "";
		width: 0;
		height: 0;
		position: absolute;
		top: 0;
		left: calc(50% - var(--size));
		border: var(--size) solid transparent;
		border-top: var(--size) solid var(--orange);
	} */
</style>
